/**
 * Complemento da copy de pendência da conexão do WhatsApp para quem não pode
 * resolvê-la (sem acesso às Configurações do setor). Única fonte: o banner
 * global de saúde e os avisos de Disparos dizem a mesma coisa (SA-1360).
 */
export const ASK_ADMIN_TO_RESOLVE = "Fale com um administrador para resolver.";
